import { animated } from '@react-spring/web';
import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const CalendarContainer = styled(animated.div)`
    box-shadow: 0 8px 24px -2px rgba(25, 54, 67, 0.2);
    background-color: ${theme.colors.background.default};
    border-radius: 16px;
    transform-origin: var(--radix-popover-content-transform-origin);
    width: auto;
    z-index: ${theme.zIndex.interactive};
`;
